<div [formGroup]="logementForm">

    <div class="form-group">

        <!-- Code postal commune -->
        <ccd-code-postal-commune
            name="cpCommune"
            [valeur]="localite"
            [listeExclusion]="listeExclusion"
            (localiteNonEligible)="declencherModaleNonEligible = true"
            (dataChange) = "localite = $event"
            (onHttpError) = "gerrerErreursCodePostal($event)"
            >
        </ccd-code-postal-commune>

        <!-- MODALE qui bloque la simulation en cas de code postal non eligible -->
        <app-modale-code-postal-non-eligible
            [afficheModale]="declencherModaleNonEligible"
            [localite]="localite"
            (onClose)="gestionFermetureModale()">
        </app-modale-code-postal-non-eligible>

        <!-- LIEU DE RESIDENCE -->
        <ccd-boutons-radio
            *ngIf="logementForm.controls['cpCommune'].valid && (logementForm.controls['cpCommune'].touched || !logementForm.controls['cpCommune'].pristine || afficheBlocLieuResidence)"
            name="lieuResidence"
            libelle="Vous résidez en :"
            [configurationBoutons]="libelleLogement.residence_list"
            idPopup="idInfoResidencePopup"
            [valeur]="lieuResidenceValue"
            (clickPopupEvent)="clickPopup()"
            (dataChange)="lieuResidenceValue = $event"
            >
        </ccd-boutons-radio>

        <!-- Question type logement Appartement/Maison #Location# ou #Colocation# -->
        <ccd-boutons-radio
            *ngIf="lieuResidenceValue == 'APPARTEMENT_OU_MAISON' && !isDOM "
            name="typeOccupation"
            libelle="Vous êtes"
            [configurationBoutons]="libelleLogement.appart_detail_list"
            [valeur]="typeOccupationValue"
            (dataChange)="typeOccupationValue = $event"
            >
        </ccd-boutons-radio>

        <!-- Question type logement Appartement/Maison #Location# ou #Colocation# ou #Accession# -->
        <ccd-boutons-radio
            *ngIf="lieuResidenceValue == 'APPARTEMENT_OU_MAISON' && isDOM"
            name="typeOccupation"
            libelle="Vous êtes"
            [configurationBoutons]="libelleLogement.appart_detail_list_dom"
            [valeur]="typeOccupationValue"
            (dataChange)="typeOccupationValue = $event"
            >
        </ccd-boutons-radio>

        <!-- Question type logement Crous #Chambre# ou #Chambre réhabilitée# ou #Studio# -->
        <ccd-boutons-radio
            *ngIf="lieuResidenceValue == 'LOGEMENT_CROUS'"
            name="typeCrous"
            libelle="Vous logez en"
            [configurationBoutons]="libelleLogement.crous_detail_list"
            [valeur]="typeCrousValue"
            (dataChange)="typeCrousValue = $event"
            >
        </ccd-boutons-radio>

        <!-- Question es meublée -->
        <ccd-boutons-radio
            *ngIf="lieuResidenceValue == 'CHAMBRE' || (lieuResidenceValue == 'APPARTEMENT_OU_MAISON' && (typeOccupationValue == 'LOCATION' || typeOccupationValue == 'COLOCATION'))"
            name="estMeuble"
            libelle="Votre location est meublée"
            [configurationBoutons]="libelleLogement.choix_list"
            [valeur]="estMeubleValue"
            (dataChange)="estMeubleValue = $event"
            >
        </ccd-boutons-radio>

        <ccd-date 
            *ngIf="typeOccupationValue === 'ACCESSION'" 
            libelle="Date de signature du prêt principal"
            [validators]="datePrincipaleValidator" 
            [mapMessagesErreur]="mapErreurDate" 
            name="datePrPrincipale"
            [value]="datePrPrincipaleValue" 
            (dataChange)="onDateChange($event)">
        </ccd-date>

        <ccd-boutons-radio
        *ngIf="datePrPrincipaleValue != null && !isDateAnterieur() &&
            !isDatePosterieur() && typeOccupationValue === 'ACCESSION' &&
            isValidDate() && !isDateAvant1900() && logementForm.controls['datePrPrincipale']?.valid"
        name="estFinance"
        libelle="Votre acquisition fait partie d'une opération ayant reçu une décision de financement de l'État avant le 31 décembre 2018"
        [configurationBoutons]="libelleLogement.choix_list"
        [valeur]="estFinanceValue"
        (dataChange)="estFinanceValue = $event"
        >
        </ccd-boutons-radio>

        <!-- Montant de la mensualité -->
        <ccd-montant
            *ngIf="(isDateAnterieur() || isDatePosterieur() || estFinanceValue == 'true') &&
                datePrPrincipaleValue != null && isValidDate() &&
                typeOccupationValue === 'ACCESSION' && !isDateAvant1900() && logementForm.controls['datePrPrincipale']?.valid"
            libelle="Montant de la mensualité"
            [validators]="validatorsMontantPret"
            [mapMessagesErreur]="mapErreursMontantPret"
            name="mttMensualite"
            placeholder="0"
            [value]="mttMensualiteValue"
            (dataChange)="mttMensualiteValue = $event"
            >
        </ccd-montant>

        <!-- Question Le logement est conventionné -->
        <ccd-boutons-radio
            *ngIf="lieuResidenceValue == 'MAISON_RETRAITE_EHPAD' && isMetropole"
            name="estConventionne"
            libelle="Le logement est conventionné"
            [configurationBoutons]="libelleLogement.choix_conventionne_list"
            [valeur]="estConventionneValue"
            (dataChange)="estConventionneValue = $event"
            >
        </ccd-boutons-radio>

        <!-- Motant du loyer ou de la redevance -->
        <ccd-montant
            *ngIf="(['FOYER', 'RESIDENCE_SOCIALE_FJT'].includes(lieuResidenceValue) || estMeubleValue || typeCrousValue) ||
            ('MAISON_RETRAITE_EHPAD'===lieuResidenceValue && estConventionneValue && isMetropole) ||
            ('MAISON_RETRAITE_EHPAD'===lieuResidenceValue && !isMetropole)"
            [libelle]=getLibelleMontant()
            [validators]="validatorsMontantLoyer"
            [mapMessagesErreur]="mapErreursMontantLoyer"
            name="mttDeclare"
            placeholder="0"
            [value]="mttDeclareValue"
            (dataChange)="mttDeclareValue = $event"
            >
        </ccd-montant>


        <!-- Popup d'aide pour choisir son lieu de résidence parmi les propositions -->
        <div id="idInfoResidencePopup" class="d-none" role="tooltip" tabindex="-1" aria-hidden="true">
            <p>Information</p>
            <ul>
                <li>FJT : Foyer de Jeunes Travailleurs.</li>
                <li>EHPAD : Etablissement d'Hébergement des Personnes Agées Dépendantes.</li>
            </ul>
        </div>
    </div>
</div>
